module.exports = __webpack_public_path__ + "img/menu-hamburguesa.35923b02.svg";